import { DEFAULT_LOCALE, type SupportedLocale } from "@translations/config";
import { useLocale } from "./useLocale";

/**
 * Prefix a path with the current locale (`/fr` when active, nothing for English).
 *
 * Use for cross-page links so the language sticks across navigation:
 *   const href = useLocalizedHref();
 *   <a href={href("/work/equip")}>...</a>
 *
 * Accepts and returns paths that always start with "/". External URLs pass through.
 */
export function useLocalizedHref(): (path: string) => string {
  const locale = useLocale();
  return (path: string) => localizedHref(path, locale);
}

export function localizedHref(path: string, locale: SupportedLocale): string {
  if (!path.startsWith("/")) return path;
  if (locale === DEFAULT_LOCALE) return path;
  // Avoid double-prefixing if a caller already passed a localized path.
  if (path === `/${locale}` || path.startsWith(`/${locale}/`)) return path;
  return path === "/" ? `/${locale}` : `/${locale}${path}`;
}
